export default "__VITE_ASSET__82N3VGM0__"